export default function Modal({ children, isActive, clickHandle }) {
    return (
        <section
            className={`${isActive ? "visible opacity-100" : "invisible opacity-0"} transition-all duration-200 ease-in-out flex absolute top-0 right-0 bg-transparent-black w-full h-full justify-center items-center z-[99]`}
            onClick={clickHandle}
        >
            <div className={`${isActive ? "scale-100" : "scale-0"} transition-all duration-500 ease-in-out w-2/3 mx-auto shadow-lg`}
                onClick={e => e.stopPropagation()}
            >
                {children}
            </div>
        </section>
    )
}